import { googleTag } from '@ui/lib/googleTag'

// Mirrors the container's hostname rule: app.atm.com reports to the production
// property, every other host to stage. Asking for the other id still answers,
// with the right client id but a session id GA4 never saw.
export const GA4_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? 'G-P0GN92624T'
    : 'G-KHMHL616DH'

export type GaIds = {
  clientId?: string
  sessionId?: string
}

const held: GaIds = {}

const asId = (value: unknown): string | undefined =>
  typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : undefined

// A loaded tag answers at once; a page without the container never does, and
// the ids stay unknown.
export const refreshGaIds = (): void => {
  const gtag = googleTag()
  if (!gtag) return

  gtag('get', GA4_MEASUREMENT_ID, 'client_id', (value) => {
    held.clientId = asId(value)
  })
  gtag('get', GA4_MEASUREMENT_ID, 'session_id', (value) => {
    held.sessionId = asId(value)
  })
}

// What the Google tag has answered so far.
export const readGaIds = (): GaIds => ({ ...held })
